import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import OutsideClickHandler from 'react-outside-click-handler';

import media from '../utils/breakpoints';
import swatches from '../utils/swatches';

const StyledMobileMenu = styled.aside`
  ${media.desktop` display: none; `}
  box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.05);
  transform: scaleY(0);    
  transform-origin: top;
  ${media.mobile`
    max-width: 300px;
  `}
  width: 100%;
  background: ${swatches.white};
  position: absolute;
  right: 0;
  top: 60px;
  transition: transform 200ms cubic-bezier(0.55, 0.085, 0.68, 0.53);
  ${props => props.active && css`
    transform: scaleY(1);
  `}
  ul {
    box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.05);
    opacity: ${p => p.active ? 1 : 0};
    transition: opacity 200ms ease-in;
    transition-delay: 150ms;
    padding: 10px 20px;
    list-style: none;
    margin: 0;
    padding-inline-start: 0;
    li {
      height: 30px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      a {
        color: inherit;
        text-decoration: inherit;
        transition: color 0.2s;
        transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
        color: ${swatches.slate};
        &:hover {
          color: ${swatches.red};
        }
        &.active {
          text-decoration: underline;
          cursor: default;
          &:hover {
            color: currentColor;
          }
        }
      }
    }
  }
`;

export default ({ exit, active, children }) => (
  <StyledMobileMenu active={active}>
    <OutsideClickHandler 
      onOutsideClick={exit}
      disabled={!active}
    >
      {children}
    </OutsideClickHandler>
  </StyledMobileMenu>
);
